/** @format */

import template from './gb-notification-popout-b.html';
import './gb-notification-popout-b.scss';

export const GbNotificationPopoutBComponent = {
    template,
    require: {
        gbNotificationWidget: '^^',
    },
    bindings: {
        notif: '<',
    },
    controller: class GbNotificationPopoutBComponent {
        constructor() {
            'ngInject';
        }
    },
};
